import React from 'react';
import DefaultHeaderColumn from './HeaderColumns/DefaultHeaderColumn';
import SortableColumn from './HeaderColumns/SortableColumn';
import SortableDateTimeColumn from './HeaderColumns/SortableDateTimeColumn';
import { headerColumnTypes } from '../types/lists/listTypes';

const HeaderColumn = props => {
    const {
        columnType,
        labelText,
        titleText,
        isSorted,
        sortDir,
        sortByField,
        isLoading,
        sortableProps,
        ...rest
    } = props;

    const columnTypes = {
        [headerColumnTypes.SORTABLE]: (
            <SortableColumn
                labelText={labelText}
                titleText={titleText}
                sortableProps={sortableProps}
                isLoading={isLoading}
                sortByField={sortByField}
                isSorted={isSorted}
                sortDir={sortDir}
            />
        ),
        [headerColumnTypes.SORTABLE_DATE_TIME]: (
            <SortableDateTimeColumn
                labelText={labelText}
                titleText={titleText}
                sortableProps={sortableProps}
                isLoading={isLoading}
                sortByField={sortByField}
                isSorted={isSorted}
                sortDir={sortDir}
            />
        ),
    };

    const Column = columnTypes[columnType] || (
        <DefaultHeaderColumn
            labelText={labelText}
            titleText={titleText}
            {...rest}
        />
    );

    return <>{Column}</>;
};

export default HeaderColumn;
